export default __webpack_public_path__ + "static/media/us-co.a228ed80.svg";